import { getStore } from '../store/store';
import { mutatorAction } from 'satcheljs';
export default mutatorAction('setNextSearchQueryId', function (nextSearchQueryId) {
    getStore().nextSearchQueryId = nextSearchQueryId;
});
//# sourceMappingURL=setNextSearchQueryId.js.map